module.exports = __webpack_public_path__ + "img/sixpackcarrier58.5867afd7.jpg";